var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63888 21.5962C7.72804 21.6211 5.87034 20.9672 4.39638 19.7509C2.77721 18.4074 1.10244 16.308 1.05476 13.3522C0.961848 7.59303 7.04616 4.52765 10.576 5.503C10.576 5.503 13.6414 0.997824 18.2859 1.32294C19.6661 1.43997 21.0019 1.86859 22.1925 2.57654C23.3832 3.2845 24.3977 4.25333 25.1598 5.41011C25.1598 5.41011 33.9379 3.87742 35.6099 12.702C35.6154 13.6742 35.4862 14.6425 35.226 15.5793C34.7478 17.2554 33.7374 18.7306 32.3473 19.7822C30.9573 20.8339 29.2629 21.4049 27.5199 21.4092L9.63888 21.5962Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8257 26.4854H3.50586V49.5965H33.8257V26.4854Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50586 38.041H33.8257",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0986 32.5601H30.016",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0986 43.5215H30.016",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3482 14.0654H45.8204C45.9797 14.0654 46.1324 14.1287 46.245 14.2413C46.3577 14.3539 46.4209 14.5067 46.4209 14.6659V26.6533C46.4209 26.8126 46.4842 26.9653 46.5968 27.0779C46.7094 27.1905 46.8622 27.2538 47.0214 27.2538H48.3443C48.4579 27.2538 48.5691 27.286 48.665 27.3466C48.761 27.4072 48.8379 27.4938 48.8866 27.5963C48.9354 27.6988 48.9541 27.8131 48.9406 27.9258C48.9271 28.0385 48.8819 28.1451 48.8103 28.2332L43.7048 34.5129C43.6483 34.5825 43.5769 34.6385 43.4959 34.6769C43.4148 34.7152 43.3263 34.735 43.2366 34.7346C43.147 34.7343 43.0586 34.7139 42.9779 34.6749C42.8971 34.636 42.8261 34.5795 42.7701 34.5095L37.7412 28.2297C37.6704 28.1414 37.6261 28.0349 37.6133 27.9225C37.6004 27.8101 37.6196 27.6963 37.6686 27.5943C37.7176 27.4923 37.7944 27.4063 37.8901 27.346C37.9859 27.2858 38.0968 27.2538 38.2099 27.2538H40.0892C40.248 27.2538 40.4003 27.191 40.5128 27.079C40.6253 26.967 40.6889 26.815 40.6897 26.6562L40.7477 14.663C40.7484 14.5043 40.812 14.3523 40.9246 14.2403C41.0371 14.1283 41.1894 14.0654 41.3482 14.0654Z",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.451172)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg13);
export default __webpack_public_path__ + "static/media/Website icons SVG-13.b379a15019461be3c30f5b50ac0b3c3c.svg";
export { ForwardRef as ReactComponent };